export default __webpack_public_path__ + "static/own-pace-37451d3fc5a85b9a73bc074dc9b0f8b2.png";